module.exports = __webpack_public_path__ + "img/061.ae1e5b01.jpeg";